import { Typography } from '@sravni/react-design-system';

import { BANKS_IDS } from 'constants/banks';
import { OFFER_STATUS } from 'constants/offer';

import { isPreApprovalOffer } from 'shared/lib';
import type { TOffer } from 'shared/types/TRankingService';

import { OFFER_NOTE_TEXTS } from '../config/offerNote.texts';
import type { IOfferNoteData } from '../types';

import { generateLinks } from './generateLinks';

// eslint-disable-next-line max-statements, complexity
export const createOfferNoteDataFromOffer = (offer: TOffer, isActiveGroup = false): IOfferNoteData | null => {
  if (offer?.additionalInfo?.isFake) {
    return OFFER_NOTE_TEXTS.fake;
  }

  if (offer?.additionalInfo?.isPreapproving) {
    return null;
  }

  if (isPreApprovalOffer(offer) && offer?.preApprovalOffer?.description) {
    return {
      title: '',
      description: offer?.preApprovalOffer?.description,
      color: 'green',
    };
  }

  if (offer.status === OFFER_STATUS.QUEUED) {
    return generateLinks(OFFER_NOTE_TEXTS.queued, offer.phones);
  }

  if (offer.status === OFFER_STATUS.NEW) {
    if (offer?.additionalInfo?.isAutoPledge) {
      return OFFER_NOTE_TEXTS.autoPledge;
    }
    if (offer?.additionalInfo?.isPropertyPledge) {
      return OFFER_NOTE_TEXTS.propertyPledge;
    }
  }

  // Микрокредиты
  if (offer.category === 'MicroCredit') {
    if (offer.status === OFFER_STATUS.ISSUED) {
      return OFFER_NOTE_TEXTS.microCredit.issued;
    }

    if (offer.status === OFFER_STATUS.ACCEPTED) {
      return OFFER_NOTE_TEXTS.microCredit.accepted;
    }
    if (offer.status === OFFER_STATUS.PREAPPROVED || offer.status === OFFER_STATUS.APPROVED) {
      return OFFER_NOTE_TEXTS.microCredit.approved;
    }
    if (offer.status === OFFER_STATUS.REFUSED || offer.status === OFFER_STATUS.FAILED) {
      return OFFER_NOTE_TEXTS.microCredit.refused;
    }

    if (offer.status === OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK) {
      return generateLinks(OFFER_NOTE_TEXTS.microCredit.alreadySent, offer.phones);
    }

    if (offer?.additionalInfo?.authLink) {
      return OFFER_NOTE_TEXTS.microCredit.issued;
    }

    if (offer.type === 'mfoStatus') {
      return {
        ...OFFER_NOTE_TEXTS.microCredit.mfo,
        color: offer?.additionalInfo?.dealStatus === 'rejected' ? 'orange' : 'blue',
        description: offer?.additionalInfo?.referralLink
          ? ((
              <>
                {offer?.additionalInfo?.infoText}{' '}
                <Typography.Link href={offer?.additionalInfo?.referralLink}>
                  {offer?.additionalInfo?.referralLinkText}
                </Typography.Link>
              </>
            ) as any)
          : offer?.additionalInfo?.infoText,
      };
    }

    return null;
  }

  if (offer.status === OFFER_STATUS.ISSUED) {
    return OFFER_NOTE_TEXTS.credit.issued;
  }

  if (offer.status === OFFER_STATUS.ACCEPTED) {
    return generateLinks(
      {
        ...OFFER_NOTE_TEXTS.credit.accepted,
        buttonLabel: isActiveGroup ? undefined : OFFER_NOTE_TEXTS.credit.accepted.buttonLabel,
      },
      offer.phones,
    );
  }
  if (offer.status === OFFER_STATUS.PREAPPROVED) {
    return generateLinks(OFFER_NOTE_TEXTS.credit.preapproved, offer.phones);
  }
  if (offer.status === OFFER_STATUS.APPROVED) {
    return generateLinks(OFFER_NOTE_TEXTS.credit.approved, offer.phones);
  }
  if (offer.status === OFFER_STATUS.REFUSED || offer.status === OFFER_STATUS.FAILED) {
    return OFFER_NOTE_TEXTS.credit.refused;
  }
  if (offer.status === OFFER_STATUS.ALREADY_SENT_FROM_SAME_BANK) {
    if (offer.bankId === BANKS_IDS.OTKRITIE) {
      return generateLinks(OFFER_NOTE_TEXTS.credit.alreadySentOtkritie, offer.phones);
    }
    return generateLinks(OFFER_NOTE_TEXTS.credit.alreadySent, offer.phones);
  }

  if (offer?.additionalInfo?.authLink) {
    return generateLinks(OFFER_NOTE_TEXTS.credit.preapproved, offer.phones);
  }

  return null;
};
